<template>
  <div 
    class="position-relative" 
    v-on:mouseover="showTooltip($event)"
  >
    <div class="desc-tooltip">
      <div
        style="
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
        "
      >
        {{ DescritionData }}
      </div>
    </div>
    <!-- مربوط به نمایش tooltip -->
    <span 
      v-if="DescritionData.length > 5"
      class="hovercard"
    >
      <div class="tooltiptext" ref="tooltiptext">
        {{ DescritionData }}
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: "DescriptionByTooltip",
  props: {
    // متن راهنما
    DescritionData: {type: String, default: '...'},
    // نمایش کادر در بالا یا پایین
    showTop: {type: Boolean, default: false},
  },
  mounted: function() {
    // در لحظه ایجاد کامپاننت داکیومنت را در متغییر محلی قرار می دهد
    // از این متغییر محلی جهت مدیریت محل نمایش کامپاننت استفاده می شود
    this.root = document.documentElement;
  },
  data() {
    return {
      root: null,  // متغییر عمومی نماینده داکیومنت
    };
  },
  methods: {
    showTooltip(event){
      if(this.DescritionData.length > 5){
        let TopNum = 0;      
        if(this.showTop == true){
          // نمایش سمت بالا
          TopNum = (this.$refs.tooltiptext.clientHeight + 10) * -1;
        } else {
          // نمایش سمت پایین
          TopNum = 28;
        }
        // مقداردهی به متغییر کنترل موقعیت ارتفاع تولتیپ
        this.root.style.setProperty("--top-number", TopNum + "px");
      }
    },
  }
};
</script>

<style>
:root {
      /* متغییر کنترل موقعیت ارتفاع تولتیپ */
      --top-number: 0px;
    }
.hovercard {
  position: absolute;
  display: none;
  opacity: 0;
  z-index: 1;
  top: var(--top-number);
  width: 100%;
  height: 100%;
}
.desc-tooltip:hover ~ .hovercard {
  display: block;
  opacity: 1;
}
.tooltiptext {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #d3eaea;
  padding: 18px;
  border-radius: 5px;
  color: #343a40;
  line-height: 15px;
  direction: rtl;
  text-align: justify;
  box-shadow: rgb(0 0 0 / 60%) 0px 1px 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/PublicComponents/DescriptionByTooltip.vue